/**
 * Renders the small markdown subset used in editable texts (admin → Textos):
 * "## Título", "- elemento de lista", **negrita** and blank-line separated paragraphs.
 */
export default function RichText({ text, className = "" }) {
  const blocks = String(text || "").split(/\n{2,}/);
  return (
    <div className={`space-y-4 ${className}`}>
      {blocks.map((block, i) => {
        const lines = block.split("\n").filter((l) => l.trim() !== "");
        if (!lines.length) return null;
        const heading = lines[0].startsWith("## ") ? lines.shift().slice(3) : null;
        const isList = lines.length > 0 && lines.every((l) => l.trim().startsWith("- "));
        return (
          <div key={i}>
            {heading && <h2 className="text-lg md:text-xl font-medium mt-6 mb-2">{inline(heading)}</h2>}
            {isList ? (
              <ul className="space-y-1.5">
                {lines.map((l, j) => (
                  <li key={j} className="flex gap-2.5">
                    <span className="text-muted-foreground">—</span>
                    <span>{inline(l.trim().slice(2))}</span>
                  </li>
                ))}
              </ul>
            ) : (
              lines.length > 0 && <p className="whitespace-pre-line">{inline(lines.join("\n"))}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}

function inline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i}>{part.slice(2, -2)}</strong> : part,
  );
}
